import React, { useEffect, useRef } from 'react'
import { useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import HomeVideo from '../../assets/images/check-video.mp4';

export default function OpenSource() {
    const swiperRef1 = useRef();

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>

            <section className="inner-banner" style={{ position: 'relative', overflow: 'hidden' }}>
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1,
                    }}
                >
                    <source src={HomeVideo} type="video/mp4" />
                </video>
                <h1 className='heading'>Open Source Software</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><Link to="#">Home</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item"><Link to="/services">Services</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item active" aria-current="page">Open Source Software</li>
                    </ol>
                </nav>
            </section>

            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='header-title mb-40px'>
                                <h3 className='heading wow fadeInUp' >Open Source Software Management</h3>
                                <p className='paragraph'>
                                    Open source software has transformed how developers build applications, providing a wealth of pre-built components that significantly enhance productivity and drive innovation.
                                    By harnessing the collective expertise of a global community, developers can create complex,
                                    feature-rich applications much faster than building from scratch. However, this power comes with important risks associated with the open source model.  </p>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='service-left-image' style={{ backgroundColor: '#ffff', borderRadius: '50px' }}>
                                <img src={require('../../assets/images/services/open-source-2.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                    <div className="row top">
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/depth-perception.webp')} alt="anytime" />
                                <h2>Depth</h2>
                                <p>Our hackers go in depth to find vulnerabilities in your system.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/service.webp')} alt="Mobile Application Development" />
                                <h2>Standards</h2>
                                <p>We use industry standard tools to find even the bad loopholes.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/receipt.webp')} alt="Mobile App Development Services " />
                                <h2>Report</h2>
                                <p>Get a penetration testing report that's written in layman language.</p>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="software-develop cyberfortify">
                                <img src={require('../../assets/images/services/Network/comment.webp')} alt="Mobile App Development Services " />
                                <h2>Good News</h2>
                                <p>Yes, your free consultation is just a click away.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='achievement-section top bottom' style={{ background: '#101218' }}>
                <div className='container'>
                    <div className='header-title text-center'>
                        <h2 className='heading wow fadeInUp'>Open Source Management Services: Key Points</h2>
                        <p>Here is the general process for securing access and managing access control within an organization:</p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-2'></div>
                        <div className='col-lg-8'>
                            <p className='paragraph'><b>1 Cost-Effectiveness :</b> Open source management services often reduce costs associated with software licensing and maintenance, allowing organizations to allocate resources more efficiently.</p>
                            <p className='paragraph'><b>2 Customization :</b> These services enable organizations to tailor software solutions to meet specific needs, ensuring greater flexibility and adaptability.</p>
                            <p className='paragraph'><b>3 Community Support : </b>  Open source projects typically have active communities that provide support, documentation, and regular updates, enhancing the software's reliability and functionality.</p>
                            <p className='paragraph'><b>4 Security :</b> While open source software is publicly accessible, its transparency allows for thorough security assessments by the community, leading to quicker identification and resolution of vulnerabilities.</p>
                            <p className='paragraph'><b>5 Integration :</b> Open source management services facilitate the integration of various tools and platforms, enabling organizations to create cohesive and efficient workflows.</p>
                            <p className='paragraph'><b>6 Innovation :</b> The collaborative nature of open source fosters rapid innovation, as developers worldwide contribute to improving and expanding software capabilities.</p>
                            <p className='paragraph'><b>7 Vendor Independence :</b> Utilizing open source solutions reduces dependency on specific vendors, providing organizations with greater control over their software stack and long-term sustainability.</p>
                            <p className='paragraph'><b>8 Scalability :</b> Open source management services can easily scale to meet the growing demands of an organization, accommodating increased users and features without significant additional costs.</p>
                        </div>
                        <div className='col-lg-2'></div>
                    </div>
                </div>
            </section>

            <section className='more-services mb-0' >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='header-title mb-40px top'>
                                <h3 className='heading wow fadeInUp' >Open Source as a Service</h3>
                                <p className='paragraph'>We have collaborated with a variety of industries, including Airlines, Supply chains, Fintech, Health-tech, e-commerce, etc. We believe that a pentest will have the greatest impact on a company when the pentesting team has a thorough understanding of the web application’s API business logic. Therefore, we dedicate a specialized team to comprehending the business logic of the issue at hand.</p>
                            </div>
                        </div>
                        <div className='col-lg-6 mb-40px top service-more-detials'>
                            <div className="cards">
                                <div className='box-text'>
                                    <h4 className='heading'>Explore More Services</h4>
                                    <p className='paragraph'>"Discover comprehensive cybersecurity solutions to safeguard your digital assets today."</p>
                                    <div className='services-button'>
                                        <Link to="/services">
                                            <button className='btn footer-btn btn-class'>More Services<span>More Services</span></button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </section>

            <section className='faq-section-b bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <h2 className='heading text-center text-dark' style={{ fontWeight: 'bold' }}>Frequently Asked Questions</h2>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='service-detail-left-side'>
                                <div className='faq-section-inner'>
                                    <div class="accordion wow fadeInUp" id="accordionExample">
                                        <div className='faq-box'>

                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        How does consumer marketing differ from other forms of marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Consumer marketing focuses specifically on understanding and targeting individual consumers, whereas other forms of marketing may target businesses or broader market segments.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        What strategies does Brand Street use to engage consumers?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We utilize a variety of strategies including targeted messaging, personalized experiences, influencer partnerships, and interactive content to engage consumers and drive brand affinity.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        How does Brand Street ensure that its consumer marketing campaigns resonate with target audiences?
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We conduct thorough audience research and employ data-driven insights to tailor our campaigns to the unique preferences and behaviors of our target audience.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                        Can Brand Street help with both B2C and B2B consumer marketing?
                                                    </button>
                                                </h2>
                                                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        Yes, we have experience working with clients in both B2C and B2B industries, developing customized strategies to effectively reach and engage their respective target audiences.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                                        What types of consumer marketing channels does Brand Street utilize?
                                                    </button>
                                                </h2>
                                                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div class="accordion-body">
                                                        We leverage a mix of traditional and digital channels including social media, email marketing, content marketing, experiential activations, and influencer partnerships to reach and engage consumers across multiple touchpoints.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
